import UAParser from 'ua-parser-js';

const parser = new UAParser();

export const isIos = () => parser.getOS().name === 'iOS';
export const isAndroid = () => parser.getOS().name === 'Android';

export const deviceOsName = () => parser.getOS().name;

export const isMobileDevice = () => parser.getDevice().type === 'mobile';

export const isTabletDevice = () => parser.getDevice().type === 'tablet';
